// extracted by mini-css-extract-plugin
export default {"wrapper":"Popover_wrapper__AYtYQ","panel":"Popover_panel__-4mWe","trigger":"Popover_trigger__dM-7E"};